export const COURSE_TABS = [
    { value: "notebook", label: "Cuaderno" },
    { value: "tasks", label: "Tareas" },
    { value: "schedule", label: "Itinerario" },
    { value: "info", label: "Ficha" },
];
